module.exports = __webpack_public_path__ + "img/icon_map_32_off_111.b1c65767.png";